const isFullArray = value => Array.isArray(value) && value.length > 0;

// noinspection JSUnusedGlobalSymbols
export default isFullArray;
